import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-card-content',
    templateUrl: 'cs-card-content.html',
    host: { 'class': 'card-content' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsCardContentComponent {
}